<template>
    <el-dialog title="文件上传" :close-on-click-modal="false" :visible.sync="visible" width="1130px">
        <el-form :rules="dataRule" ref="dataForm" label-width="120px" :inline="true">
            <el-row>
                <el-col :span="24">
                    <el-upload ref="uploadFile" class="upload-demo" action="action" :http-request="uploadFile" drag
                        multiple :show-file-list=false :auto-upload="true">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-col>
                <el-col :span="24">
                    <span style="color: red;">
                        支持同时上传多个文件，上传文件类型推荐为PDF，考虑网络负载，不建议单次上传太多的文件，可以分批上传
                    </span>
                </el-col>
            </el-row>
            <el-row style="padding: 20px 0;">
                <el-col :span="4"
                    style="border: 1px solid #dadada;background-color: #E1F1FF;padding: 10px;color: #00428E;">
                    <span>待上传的文件类型</span>
                </el-col>
                <el-col :span="20"
                    style="border: 1px solid #dadada;border-left: 0px;padding: 10px;font-weight: bolder;">
                    <span>{{ uploadFilekindName }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-table :data="recordList" style="width: 100%" :cell-style="{ padding: '0px' }" border>
                        <el-table-column type="index" label="序号" width="80">
                        </el-table-column>
                        <el-table-column label="文件名称" width="300" align="center">
                            <template slot-scope="scope">
                                <el-input class="sp-input" v-model="scope.row.fileName" placeholder="文件名称"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="上传时间" width="190" align="center">
                            <template slot-scope="scope">
                                <el-date-picker v-model="scope.row.uploadTime" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column label="上传人" width="200" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.uploadMan" placeholder="上传人"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="200" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.remark" placeholder="备注"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button v-preventReClick type="text" size="small"
                                    @click="downloadFile(scope.row.fileUri, scope.row.fileName)">查看</el-button>
                                <el-button v-preventReClick type="text" size="small"
                                    @click="delFile(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-form>
        <el-row class="formBtnGroup">
            <el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()"
                :disabled="this.recordList == undefined || this.recordList.length == 0">保存</el-button>
            <el-button v-preventReClick class="rebtn" size="small" @click="visible = false">取消</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    name: "filedetail-add-or-update",
    data() {
        return {
            visible: false,
            selectFileKind: {
                stepCode: '',
                filekindcode: '',
                subclasscode: '',
                systemFlg: ''
            },
            recordList: [],
            action: "",
            uploadFilekindName: '',
            dataRule: {
            },
        }
    },
    methods: {
        init(selectFileKind) {
            this.visible = true;
            this.selectFileKind = selectFileKind
            this.recordList = []
            this.getUploadFileKindName();
        },
        getCurrentTime() {
			//获取当前时间并打印
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			return yy + '-' + mm + '-' + dd;
		},
        getUploadFileKindName() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/projectfilekind/getUploadFileKindName",
                method: 'get',
                params: this.$http.adornParams({
                    subclasscode: this.selectFileKind.subclasscode,
                    workNo: $common.getItem("workNo"),
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.uploadFilekindName = data.body;
                }
            })
        },
        uploadFile(param) {
            const formData = new FormData();
            let upData = []

            for (let i = 0; i < this.$refs.uploadFile.uploadFiles.length; i++) {
                upData.push(this.$refs.uploadFile.uploadFiles[i].raw);
                formData.append('files', this.$refs.uploadFile.uploadFiles[i].raw);
            }
            this.$refs.uploadFile.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/uploadMultipleFile/" + $common.getItem("workNo") + "/92/" + this.selectFileKind.subclasscode,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                },
            ).then(res => {
                res = res.data;
                if (res.resultCode === 200) {
                    res.body[0].filePath = res.body[0].fileSavePath
                    res.body[0].fileName = this.extractFileName(res.body[0].fileName)
                    res.body[0].uploadMan = $common.getItem("userName")
                    res.body[0].uploadTime = this.getCurrentTime()
                    res.body[0].remark = ''
                    this.recordList.push(res.body[0])
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        downloadFile(fileUri, filename) {
            filename = this.getSuffix(fileUri, filename)
            this.getBlob(fileUri, (blob) => {
                this.saveAs(blob, filename)
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        delFile(index) {
            this.recordList.splice(index, 1)
        },
        dataFormSubmit() {
            const _url = "/business/projectfiledetail/save";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData({
                    workNo: $common.getItem("workNo"),
                    recordList: this.recordList,
                    stepCode: this.selectFileKind.stepCode,
                    filekindcode: this.selectFileKind.filekindcode,
                    subclasscode: this.selectFileKind.subclasscode,
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            this.$parent.getDataList();
                        }
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        }
    }
}
</script>
<style scoped>
.addFileBox {
    display: inline-block;
    margin-right: 10px;
}

.upload-demo /deep/ .el-upload-dragger {
    width: 1070px;
    height: 100px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
    font-size: 40px;
    margin: 0 0;
    line-height: 60px;
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
    line-height: 20px;
}

.item::v-deep .el-form-item__label {
    color: #00428E !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: #E1F1FF;
    white-space: nowrap !important;
    border-right: solid #dadada 1px;
}

.border-form .el-row.set_border {
    border-bottom: solid #dadada 1px;
    border-left: solid #dadada 1px;
    border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
    border-top: solid #dadada 1px;
}

.border-form .el-row.set_border .col-set_border {
    border-right: solid #dadada 1px;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.sp-input /deep/ .el-input__inner {
    width: 100% !important;
    margin: 2px 0;
}
</style>
